export default {
  // حالت‌ها
  "common.mode.auto": "حالت خودکار (استفاده از انرژی تولیدی داخلی)",
  "common.mode.economy": "حالت اقتصادی",
  "common.mode.exigency": "حالت اضطراری",

  // دستگاه‌ها
  "common.grid": "شبکه برق",
  "common.evChargers": "شارژرهای خودروهای الکتریکی (چندتایی)",
  "common.evCharger": "شارژر خودروهای الکتریکی",
  "common.pv": "انرژی خورشیدی (PV)",
  "common.inverter": "اینورتر (دستگاه تبدیل ولتاژ)",
  "common.pcs": "اینورتر + باتری",
  "common.terminal": "دستگاه ترمینال",
  "common.airc": "کولر هوا (AC)",
  "common.engine": "موتور",
  "common.battery": "باتری",
  "common.metter": "متر برق",
  "common.other": "سایر موارد",
  "common.power": "توان",
  "common.powerTotal": "توان کل",
  "common.voltage": "ولتاژ",
  "common.electricity": "برق",
  "common.current": "جریان الکتریکی",
  "common.homeUsage": "بار کل خانه",
  "common.battery.power": "توان باتری",

  // داده‌ها
  "common.noDataAvailable": "اطلاعاتی در حال حاضر در دسترس نیست~",
  "common.tips": "نکات",
  "common.reset": "ریست (پاک کردن)",
  "common.currencyUnit": "¥ (یوان)",
  "common.submiting": "ارسال 중... لطفاً صبر کنید...",
  "common.close": "بستن",
  "common.from": "از",
  "common.useIn": "برای",
  "common.energyPercent": "درصد جریان انرژی",
  "common.dataFlow": "جریان داده",
  "common.getDataIng": "دریافت داده‌ها... لطفاً صبر کنید...",
  "common.pageLoading": "بارگذاری صفحه... لطفاً صبر کنید...",
  "common.reseting": "ریست صفحه... لطفاً صبر کنید...",
  "common.save": "ذخیره",
  "common.onlyNumberTips": "فقط عدد می‌تواند وارد شود",
  "common.offline": "آفلاین (عدم اتصال به اینترنت)",
  "common.online": "آنلاین (اتصال به اینترنت)",
  "common.fault": "خطا (مشکل)",
  "common.charge": "شارژ (باتری)",
  "common.discharge": "ریزشارژ (استفاده از انرژی باتری)",
  "common.buy": "خرید",
  "common.sell": "فروش",
  "common.loadingInfo": "بارگذاری... لطفاً صبر کنید...",

  // عملکردهای عمومی
  "common.moreFeatures": "عملکردهای بیشتر",
  "common.confirm": "تایید",
  "common.saveing": "ذخیره 중... لطفاً صبر کنید...",
  "common.searchPlacholder": "کلمه کلیدی را برای جستجو وارد کنید",
  "common.iSee": "فهمیدم",
  "common.pageErrorTips1": "اوه، خطایی در صفحه رخ داده است~",
  "common.pageErrorTips2": "صفحه را دوباره بارگذاری کنید یا با پشتیبانی تماس بگیرید~",
  "common.refresh": "بارگذاری مجدد",
  "common.backToHome": "بازگشت به صفحه اصلی",
  "common.checkTips": "بررسی 중... لطفاً صبر کنید...",
  "common.back": "بازگشت",
  "common.cancel": "لغو (حذف)",
  "common.optional": "اختیاری (اجباری نیست)",
  "common.required": "اجباری برای پر کردن",
  "common.status": "وضعیت",
  "common.statusNoDelete": "حذف نشده",
  "common.statusDelete": "حذف شده",
  "common.submit": "ارسال",
  "common.disable": "غیرفعال کردن",
  "common.enable": "فعال کردن",
  "common.year": "سال",
  "common.month": "ماه",
  "common.day": "روز",
  "common.version": "نسخه:",
  "common.backHome": "بازگشت به صفحه اصلی",
  "common.backHomeSorry": "متاسفیم، این صفحه نامعتبر است",
  "common.requestTips1": "دریافت داده‌ها در حال انجام است، لطفاً دوباره ارسال نکنید",
  "common.requestTips2": "اطلاع‌رسانی‌های سیستم",
  "common.requestTips3": "جلسه ورود منقضی شده است، لطفاً دوباره وارد شوید",
  "common.requestTips4": "ورود مجدد",
  "common.requestTips5": "ورود نامعتبر است یا جلسه منقضی شده است، لطفاً دوباره وارد شوید.",
  "common.requestTips6": "خطای سرور، لطفاً بعداً دوباره امتحان کنید.",
  "common.requestTips7": "درخواست سیستم منقضی شده است",
  "common.requestTips8": "رابط کاربری سیستم",
  "common.requestTips9": "خطا",
  "common.iknow": "فهمیدم",
  "common.logoutSuccess": "خروج موفقانه",

  // بخش اطلاعات بیشتر
  "common.knowMore.title": "برای اطلاعات بیشتر، با Beineng تماس بگیرید",
  "common.knowMore.email": "ایمیل برای تماس",
  "common.knowMore.phone": "شماره تلفن برای تماس",
  "common.knowMore.wechat": "ویچت برای تماس",
  "common.knowMore.website": "آدرس وبسایت رسمی",
  "common.knowMore.address": "آدرس برای تماس",
  "common.knowMore.addressDetail": "واحد 1205، واحد 1301، ساختمان 5، خیابان چینگسی 8، روستا هوانگجینگکنگ، quận هوانگجیانگ، شهر دونگوان، استان Гуانگدون",

  // اتصال محلی
  "common.localConnection": "اتصال محلی",
  "common.operateInApp": "عملیات را در اپلیکیشن انجام دهید!",

  "common.enbleStaus": "وضعیت فعال",
  "common.battery.status": "شارژ نمی‌شود، ریزشارژ نمی‌شود",

  // موارد مرتبط با حساب
  "account.forgetThePassword": "فراموشی رمز عبور",
  "account.logInDirectly": "ورود مستقیم",
  "account.tips1": "تغییر صفحه... لطفاً صبر کنید...",
  "account.tips2": "ابتدا شرایط استفاده را بخوانید و بپذیرید!",
  "account.autoLogin": "ورود خودکار",
  "account.userLogin": "ورود کاربر",
  "account.registerTips": "حساب کاربری ندارید؟ برای ثبت نام اینجا کلیک کنید",
  "account.userEmail": "نام کاربری / ایمیل",
  "account.userEmailTips": "نام کاربری یا ایمیل را وارد کنید",
  "account.password": "رمز عبور",
  "account.passwordTips": "رمز عبور را وارد کنید",
  "account.submit": "ارسال",
  "account.submitTips": "ارسال 중... لطفاً صبر کنید...",
  "account.otherLoginTips": "یا روش ورود دیگری را انتخاب کنید",
  "account.userRegistration": "ثبت نام کاربر",
  "account.userName": "نام کاربری",
  "account.userNameTips": "نام کاربری را وارد کنید",
  "account.emailTips1": "آدرس ایمیل را وارد کنید",
  "account.emailTips2": "فرمت ایمیل نامعتبر",
  "account.phone": "تلفن",
  "account.phoneTips1": "شماره تلفن را وارد کنید",
  "account.phoneTips2": "شماره تلفن نامعتبر",
  "account.phoneTips3": "شماره تلفن را وارد کنید",
  "account.passwordTips1": "رمز عبور را وارد کنید (6-30 کاراکتر)",
  "account.passwordTips2": "فرمت رمز عبور نامعتبر: رمز عبور باید شامل حروف انگلیسی، اعداد، آندرلاین (_)، خط (-) و نقطه (.) باشد، طول 6-12 کاراکتر",
  "account.passwordTips3": "دو رمز عبور وارد شده مطابقت ندارند، لطفاً بررسی کرده و دوباره وارد کنید!",
  "account.passwordTips4": "رمز عبور را وارد کنید: رمز عبور باید شامل حروف انگلیسی، اعداد، آندرلاین (_)، خط (-) و نقطه (.) باشد",
  "account.passwordTips5": "تایید رمز عبور",
  "account.passwordTips6": "برای تایید رمز عبور وارد کنید",
  "account.passwordTips7": "دو رمز عبور وارد شده مطابقت ندارند، لطفاً بررسی کرده و دوباره وارد کنید!",
  "account.passwordTips8": "برای تایید رمز عبور وارد کنید",
  "account.passwordTips9": "تبریک می‌کنیم، ثبت نام موفقیت‌آمیز بود!",
  "account.passwordTips10": "نام کاربری شما:",
  "account.emailIs": "ایمیل شما:",
  "account.goToLoginPage": "به طور خودکار در s ثانیه به صفحه ورود هدایت می‌شوید",
  "account.goLogin": "ورود",
  "account.goRegister": "ثبت نام",
  "account.loginSuccess": "ورود موفقانه",
  "account.email": "ایمیل",
  "account.sologn": "ما یک پلتفرم انرژی یکپارچه را که به طور خاص برای شما طراحی شده است، ایجاد می‌کنیم",
  "account.pleaseAgree": "شرایط استفاده را خوانده و پذیرفته ام",
  "userAgreement.privacyPolicy": "سیاست حریم خصوصی",

  // موارد مرتبط با کد تایید
  "account.code": "کد تایید",
  "account.codeTips": "کد تایید را وارد کنید",
  "account.codeTips2": "کد تایید نامعتبر",

    "account.inviteCodeTips": "لطفاً کد دعوت را وارد کنید",
    "account.inviteCodeHint": "لطفاً برای دریافت کد دعوت با نصاب یا پرسنل بهره‌برداری و نگهداری تماس بگیرید",
  // تغییر و بازیابی رمز عبور
  "account.modifyPasswordByAccount": "تغییر رمز عبور از طریق حساب",
  "account.modifyPasswordByEmail": "تغییر رمز عبور از طریق ایمیل",
  "account.getPasswordByAccount": "دریافت رمز عبور از طریق حساب",
  "account.getPasswordByEmail": "دریافت رمز عبور از طریق ایمیل",

  "account.sendEmailTips": "کد تایید به ایمیل ارسال شد، لطفاً بررسی کنید",
  "account.name": "نام حساب",
  "account.newPassword": "رمز عبور جدید",
  "account.confirmNewPassword": "تایید رمز عبور جدید",
  "account.nameTips": "نام حساب را وارد کنید",
  "account.passwordModifySuccess": "تغییر رمز عبور موفقانه",
  "account.emailCode": "کد تایید ایمیل",
  "account.emailCodeTips": "کد تایید ایمیل را وارد کنید",
  "account.emailCodeTips2": "کد تایید ایمیل نامعتبر",
  "account.emailModifySuccess": "تغییر رمز عبور موفقانه",
  "account.passworTips1": "رمز عبور شما بازیابی شد!",
  "account.passwordTips11": "برای تایید رمز عبور وارد کنید",
  "account.passwordTips12": "رمز عبور جدید را وارد کنید",
  "account.nickname": "نام مستعار",
  "account.modifyNickname": "تغییر نام مستعار",
  "account.modifyNicknameSuccess": "تغییر نام مستعار موفقانه!",
  "account.nicknameTips": "نام مستعار را وارد کنید",
  "account.nicknameError": "تغییر نام مستعار ناموفق بود!",

  // ثبت نام و ورود سریع
  "account.login": "ورود",
  "account.quickRegister": "ثبت نام سریع",
  "account.sendCode": "ارسال کد تایید",
  "account.sendTips": "می‌تواند در s ثانیه دوباره ارسال شود",
  "account.sendEmailIng": "ارسال ایمیل... لطفاً صبر کنید...",
  "account.emailNotEmpty": "فیلد ایمیل نمی‌تواند خالی باشد",
  "account.registerAccount": "ثبت نام حساب",
  "account.registerWelcome": "خوش آمدید به ثبت نام SusprSafe",
  "account.usernameLimit": "نام کاربری باید با حرف شروع شود، فقط می‌تواند شامل حروف، اعداد و آندرلاین (_) باشد، طول 5-15 کاراکتر",

  // اطلاعات حق کپی‌رایت
  "copyright.desc2": "اطلاعات ثبت وبسایت: شماره ثبت ICP استان Гуانگدون 2021169764",

  // ویرایش اطلاعات کاربر
  "editUserInfo.editUserInformation": "ویرایش اطلاعات کاربر",
  "editUserInfo.modifyUsername": "تغییر نام کاربری",
  "editUserInfo.changePictures": "تغییر تصویر پروفایل",
  "editUserInfo.savePicturesSuccess": "ذخیره تصویر پروفایل موفقانه",
  "editUserInfo.saveError": "ذخیره ناموفق بود",
  "editUserInfo.pictureLimit": "حجم تصویر نمی‌تواند بیش از 2 MB باشد",
  "editUserInfo.uploadPicture": "آپلود تصویر پروفایل",
  "editUserInfo.picturePreview": "پیش نمایش",

  "editUserInfo.bindPhoneNumber": "پیوند شماره تلفن",
  "editUserInfo.bindEmail": "پیوند ایمیل",
  "editUserInfo.changePassword": "تغییر رمز عبور",

  "editUserInfo.notificationSettings": "تنظیمات اطلاع‌رسانی",
  "editUserInfo.editAccount": "ویرایش اطلاعات حساب",
  "editUserInfo.waitBingting": "در حال پیوند... لطفاً صبر کنید...",
  "editUserInfo.collapse": "شکستن (جداسازی)",
  "editUserInfo.modifyBinding": "تغییر پیوند",

  "editUserInfo.emailAddress": "آدرس ایمیل",
  "editUserInfo.tips1": "پیوند ایمیل موفقانه",
  "editUserInfo.tips2": "ذخیره ناموفق بود",
  "editUserInfo.tips3": "ارسال کد تایید ایمیل... لطفاً صبر کنید...",
  "editUserInfo.tips4": "کد تایید به ایمیل xxxx ارسال شد، لطفاً بررسی کنید",
  "editUserInfo.tips5": "ارسال کد تایید ناموفق بود!",
  "editUserInfo.tips6": "شماره تلفن پیوند شده است",
  "editUserInfo.tips7": "ایمیل پیوند شده است",
  "editUserInfo.emailTips1": "آدرس ایمیل را وارد کنید",
  "editUserInfo.emailTips2": "فرمت ایمیل نامعتبر",
  "editUserInfo.emailTips3": "می‌تواند در xxxx ثانیه دوباره ارسال شود",
  "editUserInfo.emailTips4": "ارسال کد تایید",
  "editUserInfo.emailTips5": "فیلد کد تایید ایمیل نمی‌تواند خالی باشد",
  "editUserInfo.emailTips6": "کد تایید ایمیل نامعتبر",
  "editUserInfo.emailCode": "کد تایید ایمیل",
  "editUserInfo.save": "ذخیره",

  // موارد مرتبط با پیوند تلفن
  "editUserInfo.phoneTips1": "پیوند شماره تلفن موفقانه",
  "editUserInfo.phoneTips2": "ارسال کد تایید SMS... لطفاً صبر کنید...",
  "editUserInfo.phoneTips3": "کد تایید SMS به شماره xxxx ارسال شد، لطفاً بررسی کنید",
  "editUserInfo.phoneTips4": "ارسال کد تایید SMS ناموفق بود!",
  "editUserInfo.phoneTips5": "شماره تلفن را وارد کنید",
  "editUserInfo.phoneTips6": "فرمت شماره تلفن نامعتبر",
  "editUserInfo.phoneTips7": "ارسال کد تایید SMS",
  "editUserInfo.phoneTips8": "کد تایید SMS",
  "editUserInfo.phoneTips9": "فیلد کد تایید SMS نمی‌تواند خالی باشد",
  "editUserInfo.phoneTips10": "کد تایید SMS نامعتبر",
  "editUserInfo.phone": "شماره تلفن",

  // تنظیمات اطلاع‌رسانی
  "editUserInfo.noticeTips1": "دریافت تنظیمات اطلاع‌رسانی ناموفق بود!",
  "editUserInfo.noticeTips2": "ذخیره تنظیمات اطلاع‌رسانی موفقانه!",
  "editUserInfo.noticeTips3": "اطلاع‌رسانی کمبود سطح باتری",
  "editUserInfo.noticeTips4": "اطلاع‌رسانی اتمام شارژ",
  "editUserInfo.errorNotification": "اطلاع‌رسانی خطا",
  "editUserInfo.updateNotification": "اطلاع‌رسانی به‌روزرسانی",
  "editUserInfo.monthlyStatisticsNotification": "اطلاع‌رسانی آمار ماهیانه",
  "editUserInfo.notificationMethod": "روش دریافت",

  // نکات مرتبط با نام کاربری
  "editUserInfo.userNameTips1": "ذخیره نام کاربری موفقانه",
  "editUserInfo.userNameTips2": "ذخیره نام کاربری ناموفق بود",
  "editUserInfo.userNameTips3": "نام کاربری را وارد کنید",
  "editUserInfo.userNameTips4": "فرمت نام کاربری نامعتبر: فقط می‌تواند شامل اعداد، آندرلاین (_) و حروف انگلیسی باشد",
  "editUserInfo.userNameTips5": "نام کاربری را وارد کنید",
  "editUserInfo.userNameTips6": "ذخیره 중... لطفاً صبر کنید...",
  "editUserInfo.userName": "نام کاربری",

  // نکات ویرایش تصویر پروفایل
  "editUserInfo.avatorTips": "برای تغییر تصویر پروفایل کلیک کنید",
  "editUserInfo.verifyCodeTips1": "کد تایید دریافت شده را وارد کنید:",
  "editUserInfo.verifyCodeTips2": "برای امنیت حساب شما، روی دکمه زیر کلیک کنید تا کد تایید به شماره تلفن اصلی ارسال شود:",
  "editUserInfo.verifyCodeTips3": "ارسال کد تایید",
  "editUserInfo.verifyCodeTips4": "تایید شماره تلفن اصلی موفقانه، شماره تلفن جدیدی را که می‌خواهید پیوند کنید وارد کنید",
  "editUserInfo.verifyCodeTips5": "برای امنیت حساب شما، روی دکمه زیر کلیک کنید تا کد تایید به ایمیل اصلی ارسال شود:",
  "editUserInfo.verifyCodeTips6": "تایید ایمیل اصلی موفقانه، ایمیل جدید را وارد کنید",
  "editUserInfo.verifyCodeTips7": "رمز عبور قدیمی",
  "editUserInfo.verifyCodeTips8": "ابتدا، ایمیل را پیوند کنید!",
  "editUserInfo.verifyCodeTips9": "کد تایید به ایمیل ارسال شد، لطفاً بررسی کنید",
  "editUserInfo.verifyCodeTips10": "، به طور خودکار به صفحه ورود هدایت می‌شوید",

  // موارد مرتبط با اطلاع‌رسانی
  "hems.notice.title": "عنوان اطلاع‌رسانی",
  "hems.notice.content": "محتوای اطلاع‌رسانی",
  "hems.notice.operate": "عملیات",
  "hems.notice.noRead": "خوانده نشده",
  "hems.notice.read": "خوانده شده",
  "hems.notice.warning": "هشدار",
  "hems.notice.error": "خطا",
  "hems.notice.success": "محاسبه آمار",
  "hems.notice.sys": "اطلاعات سیستم",
  "hems.notice.operateSuccess": "عملیات موفقانه",
  "hems.notice.operateTips": "عنصری را برای انجام عملیات انتخاب کنید",

  // صفحه اصلی
  "hems.home.selfuseRate": "درصد استفاده داخلی",
  "hems.home.percent": "درصد",
  "hems.home.todayData": "داده‌های امروز",
  "hems.home.todayPowerGeneration": "تولید انرژی امروز",
  "hems.home.salesIncome": "درآمد از فروش انرژی",
  "hems.home.saved": "شما صرفه‌جویی کرده‌اید",
  "hems.home.reduce": "کاهش رد مادربزرگ (کربن)",
  "hems.home.tips1": "اطلاعاتی در حال حاضر در دسترس نیست، شما هنوز xxxx را پیوند نداده‌اید",
  "hems.home.criticalLoad": "بار بحرانی",
  "hems.home.keyVoltage": "ولتاژ بحرانی",
  "hems.home.householdLoad": "بار خانه",
  "hems.home.householdVoltage": "ولتاژ خانه",
  "hems.home.generalLoad": "بار عمومی",
  "hems.home.generalVoltage": "ولتاژ عمومی",
  "hems.home.batteryHealth": "وضعیت سلامتی باتری",
  "hems.home.averageTemp": "دما متوسط",
  "hems.home.gridLoad": "بار شبکه برق",
  "hems.home.toggeleDataSource": "داده‌های نمایش داده شده به شرح زیر تغییر کرده‌اند:",
  "hems.home.toggleTips": "می‌خواهید تغییر دهید؟",
  "hems.home.modeSending": "ارسال دستور حالت... لطفاً صبر کنید...",
  "hems.home.modeSuccess": "تغییر حالت با موفقیت ارسال شد!",
  "hems.home.isOnline": "آنلاین هستید؟",
  "hems.home.useStatus": "وضعیت استفاده",
  "hems.home.workModeText": "حالت کاری فعلی:",
  "hems.home.toggleDataSourceText": "داده‌های نمایش داده شده به شرح زیر تغییر کرده‌اند:",
  "hems.ev.charge.status": "وضعیت شارژ",
  "hems.ev.charge.time": "زمان شارژ",
  "hems.ev.charge.count": "تعداد شارژ واقعی (طی زمان)",
  "hems.ev.charge.status.empty": "خالی",
  "hems.ev.charge.status.ing": "پیوند به باتری. در حال شارژ",
  "hems.ev.charge.status.null": "پیوند به باتری، اما در حال شارژ نیست",
  "hems.ev.charge.status.error": "خطا",
  "hems.hour": "ساعت",
  "hems.minue": "دقیقه",
  "hems.ev.chagre.number": "شماره شارژر",

  // راهنمای کاربر
  "hems.userGuide.selfUse": "استفاده از انرژی تولیدی داخلی",
  "hems.userGuide.selfUseTips": "ابتدا از انرژی خورشیدی استفاده کنید، اگر کافی نباشد، با شبکه برق تکمیل کنید",
  "hems.userGuide.economyMode": "حالت اقتصادی",
  "hems.userGuide.economyModeTips": "بهینه‌سازی استراتژی استفاده از انرژی بر اساس قیمت برق",
  "hems.userGuide.emergencyMode": "حالت اضطراری",
  "hems.userGuide.emergencyModeTips": "الویت دادن تأمین انرژی برای بارهای بحرانی",

  // صفحه نمودار
  "hems.history.energyStatistics": "آمار انرژی",
  "hems.history.revenueStatistics": "آمار درآمد",
  "hems.history.greenStatistics": "کاهش گازهای گلخانه‌ای",
  "hems.history.revenueTitle": "کل درآمد از فروش انرژی",
  "hems.history.savingsTitle": "کل صرفه‌جویی",
  "hems.history.carbonTitle": "کل کاهش کربن",
  "hems.history.day": "روز",
  "hems.history.month": "ماه",
  "hems.history.year": "سال",
  "hems.history.beforeDay": "روز قبل",
  "hems.history.afterDay": "روز بعد",
  "hems.history.beforeMonth": "ماه قبل",
  "hems.history.afterMonth": "ماه بعد",
  "hems.history.beforeYear": "سال قبل",
  "hems.history.afterYear": "سال بعد",
  "hems.history.totalUse": "کل استفاده",
  "hems.history.fullScreen": "تمام صفحه",
  "hems.history.timeSelect": "روز را انتخاب کنید",
  "sync.tips1": "دستور همگام‌سازی داده‌ها با موفقیت ارسال شد!",
  "sync.tips2": "همگام‌سازی داده‌ها در حال انجام است، به دلیل حجم زیاد داده‌ها زمان می‌برد، بعد از 50 دقیقه دوباره بررسی کنید~",
  "sync.tips3": "همگام‌سازی داده‌های دستگاه ممکن است تأخیر داشته باشد، اگر ناسازگاری در داده‌ها مشاهده می‌کنید، روی دکمه زیر کلیک کنید:",
  "sync.tips4": "همگام‌سازی داده‌ها",

  // اطلاعات شارژر
  "charge.info": "اطلاعات شارژر",
  "news.loading": "بارگذاری...",
  "news.noMore": "اطلاعات دیگری وجود ندارد",
  "hems.pv.power": "مقدار انرژی خورشیدی",

  // عملکردهای خاص UEH
  "ueh.sellPower": "مقدار انرژی برای فروش",

  // منو
  "menu.home": "صفحه اصلی",
  "menu.history": "داده‌های تاریخی",
  "menu.device": "دستگاه‌ها",
  "menu.settings": "تنظیمات",
  "menu.messageCenter": "مرکز پیام‌ها",
  "menu.help": "راهنمایی و پشتیبانی",
  "menu.mine": "من (شخصی)",

  // تنظیمات من
  "mine.userSetting": "تنظیمات کاربر",
  "mine.terminalSetting": "تنظیمات پایه ترمینال",
  "mine.uploadCloud": "آپلود داده‌ها به ابری",
  "mine.changeVersion": "بررسی به‌روزرسانی",
  "mine.language": "تغییر زبان",
  "mine.about": "درباره اپلیکیشن",
  "mine.feedback": "بازخورد",
  "mine.logout": "خروج",
  "mine.logoutAccount": "حذف حساب",

  // موارد مرتبط با حذف حساب
  "mine.logoutAccountTips": "حذف حساب با نام []",
  "mine.logoutAccountTips1": "حذف حساب پیوند شده با []",
  "mine.logoutAccountCare": "نکات درخواست حذف حساب:",
  "mine.logoutAccountCare1": "1. حساب در وضعیت امن است",
  "mine.logoutAccountCare1-1": "حساب در حالت استفاده عادی است، خطر سرقت، نقض قوانین یا بستن وجود ندارد",
  "mine.logoutAccountCare2": "2. دسترسی و پیوند حساب حذف می‌شوند",
  "mine.logoutAccountCare2-1": "همه دسترسی‌های حساب به پلتفرم‌های ثالث حذف می‌شوند",
  "mine.logoutAccountCare3": "3. پس از حذف، حساب نمی‌تواند بازیابی شود، داده‌های کاربر حذف می‌شوند",
  "mine.logoutAccountCare3-1": "پس از حذف، شماره تلفن، ایمیل و داده‌های مرتبط که پیوند شده‌اند حذف می‌شوند و نمی‌توانند بازیابی شوند",
  "mine.confirmLogout": "تایید حذف",
  "mine.logoutSuccess": "حساب با موفقیت حذف شد!",

  // مشکلات بازخورد
  "mine.feedbackIssues": "مشکلات و بازخورد",
  "mine.feedQuantity": "مقدار",
  "mine.feedAmount": "حداکثر 9 تصویر، حداکثر حجم هر تصویر 1 MB",

  // موارد مرتبط با تنظیمات اطلاع‌رسانی
  "mine.notice.fail": "دریافت تنظیمات اطلاع‌رسانی ناموفق بود!",
  "mine.notice.saveSuccess": "ذخیره تنظیمات اطلاع‌رسانی موفقانه!",
  "mine.notice.saveFail": "ذخیره ناموفق بود!",
  "mine.notice.title": "تنظیمات اطلاع‌رسانی",
  "mine.notice.batteryLow": "اطلاع‌رسانی کمبود سطح باتری",
  "mine.notice.chargingFinish": "اطلاع‌رسانی اتمام شارژ",
  "mine.notice.error": "اطلاع‌رسانی خطا",
  "mine.notice.update": "اطلاع‌رسانی به‌روزرسانی",
  "mine.notice.monthly": "اطلاع‌رسانی آمار ماهیانه",
  "mine.notice.receiveType": "روش دریافت",

  // خوش آمد گویی به تنظیمات زبان
  "mine.language.welcome": "خوش آمدید به SusprSafe",
  "mine.language.desc1": "نسخه زبان را بر اساس محل اقامت خود انتخاب کنید",
  "mine.language.desc2": "شما می‌توانید آن را در هر زمان در تنظیمات اپلیکیشن تغییر دهید",

  // اطلاعات شخصی
  "mine.userInfo.avatar": "تصویر پروفایل",
  "mine.userInfo.nickname": "نام مستعار",
  "mine.userInfo.password": "رمز عبور",
  "mine.userInfo.changePassword": "تغییر رمز عبور",
  "mine.userInfo.setPassword": "تنظیم رمز عبور",
  "mine.userInfo.phoneNumber": "شماره تلفن",
  "mine.userInfo.bindPhone": "پیوند تلفن",
  "mine.userInfo.bindEmail": "پیوند ایمیل",
  "mine.loginExpired": "جلسه ورود منقضی شده است، لطفاً دوباره وارد شوید",
  "mine.userInfo.title": "اطلاعات کاربر",
  "mine.userInfo.bind": "پیوند",
  "mine.userInfo.modify": "ویرایش",
  "mine.userInfo.modifyNickname": "تغییر نام مستعار",
  "mine.userInfo.userNickname": "نام مستعار کاربر",
  "mine.userInfo.selectPic": "تصویری را برای آپلود انتخاب کنید",
  "mine.userInfo.saveSuccess": "ذخیره موفقانه",
  "mine.userInfo.uploadFail": "آپلود ناموفق بود",
  "mine.userInfo.avatarSaveSuccess": "ذخیره تصویر پروفایل موفقانه",
  "mine.userInfo.nameTips1": "فیلد نام مستعار نمی‌تواند خالی باشد",
  "mine.userInfo.nameTips2": "نام مستعار را وارد کنید",

  // نکات انتخاب عمومی
  "common.pleaseSelect": "لطفاً انتخاب کنید",
  "question.commonQuestions": "سوالات متداول",
  "account.toggleLanguage": "تغییر زبان",
  "account.localConnection": "اتصال محلی",
  "account.selectLanguage": "لطفاً زبان را انتخاب کنید",
  "account.sendEmailToast": "کد تایید به ایمیل xxx ارسال شد، لطفاً بررسی کنید",
  "account.emailError": "فرمت ایمیل نامعتبر",
  "account.sendEmailFail": "ارسال ناموفق بود، لطفاً دوباره تلاش کنید",

  "common.submitting": "ارسال 중... لطفاً صبر کنید...",

  "device.page.noData": "اطلاعاتی در حال حاضر در دسترس نیست، این صفحه فقط می‌تواند در اپلیکیشن نمایش داده شود",

  // OTA Upgrade
  "bmsFirmware.upgrade": "Upgrade",
  "bmsFirmware.upgrading": "Upgrading...",
  "bmsFirmware.uploadingFile": "Uploading firmware file...",
  "bmsFirmware.upgradingProgress": "Upgrading firmware... {progress}%",
  "bmsFirmware.upgradeSuccess": "Upgrade Successful",
  "bmsFirmware.upgradeSuccessSubtitle": "BMS firmware upgrade completed!",
  "bmsFirmware.upgradeFailed": "Upgrade Failed",
  "bmsFirmware.upgradeFailedFormError": "Please check if the form is filled correctly",
  "bmsFirmware.upgradeFailedNetworkError": "Network error, please retry",
  "bmsFirmware.invalidFileType": "Please select a valid firmware file (.bin, .hex, .fw, .firmware)",
  "bmsFirmware.selectFileWarning": "Please select a firmware file first",
  "bmsFirmware.statusUpgrading": "Upgrading",
  "bmsFirmware.statusCompleted": "Upgrade Completed",
  "bmsFirmware.statusFailed": "Upgrade Failed",
  "bmsFirmware.deviceUpgrading": "Upgrading firmware package, upgrade takes 30 ~ 50 minutes, real-time device data cannot be viewed during this period, please wait...",
  "bmsFirmware.upgradeStatusLabel": "Upgrade Status",
  "bmsFirmware.upgradeProgressLabel": "Upgrade Progress",
  "bmsFirmware.currentPackageLabel": "Current transmitted data package number",
  "bmsFirmware.totalPackagesLabel": "Total data packages",
  "bmsFirmware.upgradeFailedCheckDevice": "Please check device status and retry upgrade",

  // Setting Result Dialog Translations
  "settingResult.defaultTitle": "Setting Successful",
  "settingResult.defaultSubTitle": "Parameter settings saved",
  "settingResult.confirmButton": "OK"
};